import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const ADMIN_TOKEN_KEY = 'adminAuthToken';
const ADMIN_USER_KEY = 'adminUser';

// Separate axios instance for admin endpoints
const adminAxios = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Attach admin token to every request
adminAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 redirect to admin login
adminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      clearAdminAuth();
      window.location.href = '/admin';
    }
    return Promise.reject(error);
  }
);

// ---- helpers ----
export const setAdminAuth = (token, user) => {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
  localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(user));
};

export const clearAdminAuth = () => {
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(ADMIN_USER_KEY);
};

export const getStoredAdminUser = () => {
  try {
    const raw = localStorage.getItem(ADMIN_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);

// ---- API calls ----
const adminApi = {
  login: (data) => adminAxios.post('/admin/login', data),
  me: () => adminAxios.get('/admin/me'),
  getContactForms: (limit = 200, offset = 0) =>
    adminAxios.get(`/admin/contact-forms?limit=${limit}&offset=${offset}`),
  getTenantsOverview: () => adminAxios.get('/admin/tenants'),
};

export default adminApi;
